import { ApolloClient, InMemoryCache } from '@apollo/client'

import { unauthLink } from './apolloClientLinks'

const cache = new InMemoryCache()

export const unauthClient = new ApolloClient({
  cache,
  link: unauthLink,
})
